<div class="container" [class.visible]="visible" [ngClass]="slide" [style.box-shadow]="shadow">
  <popover-close-button [class.dark_theme]="dark_theme" (onClosedClick)="close()" *ngIf="show_close_button"></popover-close-button>

  <div class="ng-content">
    <ng-content></ng-content>
    <iframe *ngIf="iframe_url" id="popover-iframe" style="width: 100%; height: 100%; border: none" [src]="iframe_url | safe: 'resourceUrl'"></iframe>
  </div>
</div>
